import styled from "styled-components";

export const AuthenticationPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  .ant-input {
    width: 23.125rem;
    background-color: ${({ theme }) => theme.colors.modalBackgroundColor};

    &:focus,
    &:hover {
      background-color: ${({ theme }) => theme.colors.modalBackgroundColor};
    }
  }

  .ant-input::placeholder,
  svg {
    color: #716d7c !important;
  }

  svg {
    font-size: 1.3rem;
    margin-right: 0.5rem;
  }

  .ant-input-affix-wrapper.ant-input-affix-wrapper-lg {
    border-color: ${({ theme }) => theme.colors.modalBackgroundColor};
    background-color: ${({ theme }) => theme.colors.modalBackgroundColor};
    color: ${({ theme }) => theme.colors.textColor};
    border-radius: 0.5rem;

    margin: 1.25rem 0 0;
  }

  @media (max-width: 700px) {
    height: auto;
  }

  .ant-form-vertical .ant-row {
    flex-direction: row;
  }

  .ant-input.form-control {
    width: 100%;
  }

  .gx-profile-content {
    display: flex;
    flex-direction: column;

    max-width: 1400px;
    width: 100%;
    height: 100%;
  }

  form {
    overflow: hidden;
  }

  form .ant-input-affix-wrapper.ant-input-affix-wrapper-lg {
    animation: move 500ms;
    animation-delay: 200ms;
    animation-fill-mode: backwards;
  }

  form .ant-btn {
    animation: move 500ms;
    animation-delay: 200ms;
    animation-fill-mode: backwards;
  }

  @keyframes move {
    from {
      opacity: 0;
      transform: translateX(-35%);
    }

    to {
      opacity: 1;
      transform: translateX(0%);
    }
  }
`;

export const AuthenticationPageContent = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;

  h2 {
    padding: 0 1rem;
  }

  h2,
  a,
  p {
    color: ${({ theme }) => theme.mode === "dark" && "#f5f5f5"};
  }

  @media (max-width: 1020px) {
    flex-direction: column;
  }
`;

export const LoadingContainer = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;

  max-width: 1400px;
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) =>
    theme.mode === "dark" ? "rgba(84, 84, 84, 0.5)" : "#f8f8f8ad"};

  .loader {
    left: 50%;
    top: 0;
    z-index: 1000;
    position: absolute;
  }
`;
